import { keyframes } from '@emotion/react';

export const animate = {
  WebkitAnimationDuration: '1s',
  animationDuration: '1s',
  WebkitAnimationFillMode: 'both',
  animationFillMode: 'both',
}

export const animateFast = {
  WebkitAnimationDuration: '.8s',
  animationDuration: '.8s',
  WebkitAnimationFillMode: 'both',
  animationFillMode: 'both',
}

export const animateInfinity = {
  animationIterationCount: 'infinite',
}

export const fadeIn = keyframes`
  from  {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`